export interface SoraRemixFormValues {
  videoId: string;
  prompt: string;
}

export const createInitialValues = (): SoraRemixFormValues => ({
  videoId: '',
  prompt: '',
});
